import { render, staticRenderFns } from "./RentList.vue?vue&type=template&id=136c226d&"
import script from "./RentList.vue?vue&type=script&lang=js&"
export * from "./RentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports